import { useContext, useMemo } from 'react';

import { useInspectionsTemplateCustomizeReorderEnabled } from 'react-hooks';

import UserDataContext from 'lane-shared/contexts/UserDataContext';

import type { TemplatePermissions } from '../model/operations';
import { useCustomizationState } from '../state/useCustomizationState';
import { resolveTemplatePermissions } from './resolveTemplatePermissions';

export function useTemplatePermissions(): TemplatePermissions {
  const { user } = useContext(UserDataContext);
  const { channelId } = useCustomizationState();
  const isReorderEnabled = useInspectionsTemplateCustomizeReorderEnabled();

  const { canManage, canReorder } = resolveTemplatePermissions(
    user,
    channelId,
    isReorderEnabled
  );

  return useMemo(() => ({ canManage, canReorder }), [canManage, canReorder]);
}
